import _ from 'lodash';
import React from 'react';
import {submit, formValueSelector, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Warning from 'components/Warning';
import {Totals, Buttons, InvoiceCreateForm} from './components';

import {MODALS, SCHEDULE_TYPES} from 'ducks/tenancy';
import {fetchBooking} from 'ducks/bookings';
import {calculateLineAmount, calculateTotals} from 'utils/money';

import './styles.css';

class InvoiceCreateModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.submit('invoiceCreate');
  };

  calculateLineAmount = () => {
    const {quantityValue, unitPriceValue, discountValue} = this.props.data.form;

    const quantity = Number(quantityValue || 0);
    const unitPrice = Number(unitPriceValue || 0);
    const discount = Number(discountValue || 0);

    return calculateLineAmount(quantity, unitPrice, discount);
  };

  calculateTotals = () => {
    const {taxRateValue} = this.props.data.form;

    const amount = this.calculateLineAmount();

    if (taxRateValue) {
      return calculateTotals(taxRateValue, Number(amount));
    }
    return {total: 0.0, subTotal: 0.0, subTotalVat: 0.0};
  };

  getExtraActions = ({scheduleType}) => {
    const {bookingId, tenancyId, locationRef} = this.props.data;

    let extraActions = [
      ...this.props.closeModalExtraActions,
      ...this.props.refetchExtraActions({tenancyId, scheduleType})
    ];

    // Refetch rent invoices total amount in side menu
    if (scheduleType === SCHEDULE_TYPES.RENT) {
      extraActions.push(() => fetchBooking({bookingId, locationRef}));
    }

    // Close select booking modal from booking set detail
    if (!_.isNil(this.props.closeModalSuccessExtraActions)) {
      extraActions.push(this.props.closeModalSuccessExtraActions);
    }

    return extraActions;
  };

  render() {
    const {
      data: {
        form: {submitting},
        locationRef,
        tenancyId,
        scheduleType,
        primaryTenant,
        idCounterWarningMessage,
        openFromBookingSet,
        booking
      }
    } = this.props;

    const totals = this.calculateTotals();
    const subTotal = totals && totals.subTotal;
    const total = totals && totals.total;
    const subTotalVat = totals && totals.subTotalVat;

    const lineAmount = this.calculateLineAmount();

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="InvoiceCreateModal"
        type={Modal.LARGE}>
        <Modal.Header>
          <h3 className="header">Create an Invoice</h3>
          <div className="subHeader">To {primaryTenant.fullName}</div>
        </Modal.Header>
        <Modal.Body>
          {idCounterWarningMessage && (
            <Warning>{idCounterWarningMessage}</Warning>
          )}
          <InvoiceCreateForm
            delayExtraActions={this.props.delayExtraActions}
            locationRef={locationRef}
            scheduleType={scheduleType}
            tenancyId={tenancyId}
            lineAmount={lineAmount}
            getExtraActions={this.getExtraActions}
            storeDataExtraActions={this.props.storeDataExtraActions}
            openFromBookingSet={openFromBookingSet}
            booking={booking}
          />
          <Totals subTotal={subTotal} total={total} subTotalVat={subTotalVat} />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const selector = formValueSelector('invoiceCreate');
const mapStateToModalData = state => {
  return {
    form: {
      quantityValue: selector(state, 'quantity'),
      unitPriceValue: selector(state, 'unitPrice'),
      discountValue: selector(state, 'discount'),
      taxRateValue: selector(state, 'taxRate'),
      submitting: isSubmitting('invoiceCreate')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default withModal(
  MODALS.INVOICE_CREATE,
  mapStateToModalData,
  mapDispatchToProps
)(InvoiceCreateModal);
